const expenseFlagName = '_expense_flag'

export default {
    data() {
        return {
            expenseFlagName
        }
    },
    methods: {
        isFlagged(expense) {
            return !!this.getFlagTag(expense)
        },
        getFlagTag(expense) {
            return expense.tags ? expense.tags.find(tag => expenseFlagName === tag.name) : null
        }
    }
}